import React from 'react';
import { makeStyles } from '@material-ui/core';
import loginBackground from '../../images/loginBackground.jpg';
import logo from '../../images/logo.svg';
import squareLogo from '../../images/logo-2.svg';
import headset from '../../images/headset-icon.svg';
import network from '../../images/network-icon.svg';
import funnel from '../../images/funnel-icon.svg';
import charts from '../../images/charts-icon.svg';
/*
 * inital Group Image element that is shown in the login page */

const drawerWidth = 260;

export { drawerWidth };

const useStyles = makeStyles(() => ({
  loginRight: {
    width: '100%',
  },
  loginHeader: {
    background: '#FFF',
    height: 64,
    width: '100%',
    margin: 0,
    position: 'relative',
  },
  loginTitle: {
    maxWidth: '100%',
    maxHeight: '100%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
  },
  loginBackground: {
    width: '100%',
    height: 'calc(100% - 60px)',
  },
  backgroundContent: {
    position: 'fixed',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'calc(100% - 60px)',
    width: 'calc(100% - 260px)',
    '& h1': {
      margin: 0,
      marginTop: 35,
      marginBottom: 35,
      color: '#00B5E2',
      fontFamily: 'Playfair',
      fontWeight: 300,
      fontSize: 50,
    },
  },
  loginImage: {
    width: 'calc(100% - 260px)',
    position: 'fixed',
    pointerEvents: 'none',
    objectFit: 'cover',
    objectPosition: 'center',
    height: '100%',
    maxHeight: 'calc(100% - 60px)',
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    '& img': {
      width: 50,
      padding: 40,
    },
  },
}));

const GroupImage = () => {
  const classes = useStyles();
  return (
    <div className={classes.loginRight}>
      <div className={classes.loginHeader}>
        <img src={logo} className={classes.loginTitle} alt="Hennessey Logo" height="50" />
      </div>
      <div className={classes.loginBackground}>
        <img src={loginBackground} className={classes.loginImage} alt="Group Background" />
        <div className={classes.backgroundContent}>
          <div>
            <img
              src={squareLogo}
              className={classes.topLogo}
              alt="Hennessey Second Logo"
              height="100"
            />
            <h1>Transforming Your Traffic Into Conversions</h1>
            <div className={classes.iconContainer}>
              <img src={funnel} alt="Funnel Icon" />
              <img src={charts} alt="Charts Icon" />
              <img src={network} alt="Network Icon" />
              <img src={headset} alt="Headset Icon" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupImage;
